// removed by extract-text-webpack-plugin
module.exports = {"content":"src-pages----index-module---content---30-nr","articleLink":"src-pages----index-module---articleLink---2viq-","allArticlesCenter":"src-pages----index-module---allArticlesCenter---3uNSl","allArticlesLink":"src-pages----index-module---allArticlesLink---2o7Qe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 656
// module chunks = 35783957827783